import React, { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import "./login.css";
import logo from "../assets/images/logo2.svg";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  RefreshIcon,
} from "@heroicons/react/solid";

function VerifyEmailChange() {
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [errorMessage, setErrorMessage] = useState("");
  const urls = new URLSearchParams(window.location.search);
  const token = urls.get("token");

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setStatus("error");
      setErrorMessage("Invalid or missing verification token.");
    }
  }, [token]);

  const verifyEmail = () => {
    setStatus("loading");
    axios({
      method: "GET",
      url: `${API_ENDPOINT.apiURL}Authentication/verifyEmailChange`,
      params: {
        token: token,
      },
    })
      .then((response) => {
        setStatus("success");
      })
      .catch((err) => {
        setStatus("error");
        setErrorMessage(
          err.response?.data?.message ||
            "Verification failed. Please try again or contact support.",
        );
      });
  };

  return (
    <div className="loginBg py-5">
      <div className="login">
        <div className="flex justify-center mb-4">
          <img src={logo} alt="logo" className="w-48" />
        </div>
        <div className="login_container text-center">
          {status === "loading" && (
            <div className="py-5">
              <div className="flex justify-center mb-4">
                <RefreshIcon className="h-20 w-20 text-blue-500 animate-spin" />
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Verifying Your Email
              </h3>
              <p className="text-gray-600">
                Please wait while we verify your email address..
              </p>
            </div>
          )}

          {status === "success" && (
            <div className="py-5">
              <div className="flex justify-center mb-4">
                <CheckCircleIcon className="h-20 w-20 text-green-500" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-green-600">
                Email Verified Successfully!
              </h3>
              <p className="text-gray-600 mb-4">
                Your email address has been successfully updated. You can now
                return to the app.
              </p>
              <p className="text-sm text-gray-400">
                You may close this tab now.
              </p>
            </div>
          )}

          {status === "error" && (
            <div className="py-5">
              <div className="flex justify-center mb-4">
                <ExclamationCircleIcon className="h-20 w-20 text-red-500" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-red-600">
                Verification Link Error
              </h3>
              <p className="text-gray-600 mb-2">{errorMessage}</p>
              <p className="text-sm text-gray-500">
                This link may have expired or was already used. Please request a
                new email change if needed and try again.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailChange;
